<template>
    <div class="loginbg" id="login-main-hr">
        <div class="container">
            <div class="row">
                <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
                    <div class="loginform">
                        <div class="loginlogo">
                            <img :src="logoPath" alt="Velocity Vehicle Group">
                        </div>
                        <form>
                            <div class="form-group">
                                <label for="exampleInputEmail1">Username</label>
                                <input v-model="username" type="text" name="username" class="form-control" id="username_login" placeholder="Enter Username">
                                <span class="help is-danger">{{username_error_msg}}</span>
                            </div>

                            <div class="form-group">
                                <label for="exampleInputPassword1">Password</label>
                                <input v-model="password" type="password" name="password" class="form-control" id="password_login" placeholder="Enter password">
                                <span class="help is-danger">{{password_error_msg}}</span>
                            </div>

                            <div class="help is-danger">{{error_msg_login}}</div>
                            <div class="form-check not-registered">
                            </div>
                            <div>
                                <button :disabled="disableButtons.loginButton" id="loginbtn" type="submit" class="btn btn-primary" v-on:click.prevent="login(this)">{{buttonNames.loginButton}}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import Vue from 'vue';
    import {HTTP} from '../../http-common';
    // import EventBus from '.././event-bus';
    import {
        commonMixins
    } from '../../mixins/commonMixins';
    var self;

    export default {
        name: 'Login',
        mixins: [commonMixins],
        data() {
            return {
                username: "",
                password: "",
                not_registered_url: "",
                forgot_pass_url: "",
                username_error_msg: "",
                password_error_msg: "",
                buttonNames : {
                    loginButton : 'Login',
                },
                disableButtons : {
                    loginButton : false,
                },
                error_msg_login: "",
                logoPath:'',
            }
        },
        created: function () {
        },
        beforeMount: function () {
            self = this;
            self.logoPath = process.env.LOGO_FILE_PATH;
        },
        mounted: function () {
            if(self.checkLocalStorage('/order')) {
              self.$router.push('/order');
            } else {
                localStorage.clear();
                self.$router.push("/");
                self.forgot_pass_url = process.env.HR_URL + "?identify=" + window.location.href;
                self.not_registered_url = process.env.NOT_REGISTERED_HR_URL + "?identify=" + window.location.href;
                $('#main-header').hide();
                $('#sidebar-wrapper').hide();
                $("#wrapper").addClass("login-div-full");
                $(".loginbg").show();
            }
        },
        methods: {
            login: function() {
                var error = false;
                self.username_error_msg = '';
                self.password_error_msg = '';

                if(!self.username || self.username == null || self.username == "") {
                    self.username_error_msg = "The username field is required.";
                    error = true;
                }

                if(!self.password || self.password == null || self.password == "") {
                    self.password_error_msg = "The password field is required.";
                    error = true;
                }

                if(!error) {
                    self.buttonNames.loginButton = "Login...";
                    self.disableButtons.loginButton = true;
                    /*$('#loginbtn').text("Login...");
                    $("#loginbtn").attr("disabled", true);*/

                    var fields = {
                        username: self.username,
                        password: self.password
                    };

                    HTTP.post("login", fields)
                        .then(function (data) {
                          console.log(data);
                            self.buttonNames.loginButton = "Login";
                            self.disableButtons.loginButton = false;
                            /*$('#loginbtn').text("Login");
                            $("#loginbtn").attr("disabled", false);*/

                            if (data.status == 200) {
                                localStorage.setItem("is_login", data.data.content.result);
                                localStorage.setItem("passWordChangeRequiredFlag", data.data.content.passWordChangeRequiredFlag);
                                localStorage.setItem("user_id", data.data.content.user_id);
                                localStorage.setItem("user_name", self.username);
                                /* localStorage.setItem("api_token", data.data.content.api_token);
                                localStorage.setItem("user_obj", JSON.stringify(data.data.user_obj)); */
                                window.location.href = "/order";
                            }
                            if (data.status == 201) {
                                self.error_msg_login = data.data.content;
                            }
                        })
                        .catch(function (error) {
                            self.error_msg_login = "";
                            self.buttonNames.loginButton = "Login";
                            self.disableButtons.loginButton = false;
                            /*$('#loginbtn').text("Login");
                            $("#loginbtn").attr("disabled", false);*/
                            if (error.response.status == 0) {
                                self.error_msg_login = "Remote server can not be reachable";
                            } else {
                                if (error.response.data.message) {
                                    self.error_msg_login = error.response.data.message;
                                }
                            }
                        })
                }
            },
            // checkLocalStorage : function () {
            //     if(localStorage.getItem('is_login')) {
            //         var isLogin = localStorage.getItem('is_login');
            //         if (isLogin != null && isLogin !== "" && isLogin === "1") {
            //             self.$router.push('/order');
            //         } else {
            //             self.$router.push('/');
            //         }
            //     } else {
            //         self.forgot_pass_url = process.env.HR_URL + "?identify=" + window.location.href;
            //         self.not_registered_url = process.env.NOT_REGISTERED_HR_URL + "?identify=" + window.location.href;
            //         $('#main-header').hide();
            //         $('#sidebar-wrapper').hide();
            //         $("#wrapper").addClass("login-div-full");
            //         $(".loginbg").show();
            //     }
            // },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Login/Login.vue